var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyGif(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 111,
    viewBox: "0 0 200 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.617 14.7354C196.247 14.7354 200 18.3908 200 22.9C200 27.4093 196.247 31.0647 191.617 31.0647H143.713C148.342 31.0647 152.096 34.7202 152.096 39.2294C152.096 43.7386 148.342 47.3941 143.713 47.3941H170.06C174.69 47.3941 178.443 51.0495 178.443 55.5587C178.443 60.068 174.69 63.7234 170.06 63.7234H157.876C152.038 63.7234 147.305 67.3789 147.305 71.8881C147.305 74.8943 149.701 77.6158 154.491 80.0528C159.121 80.0528 162.874 83.7082 162.874 88.2175C162.874 92.7267 159.121 96.3821 154.491 96.3821H55.0898C50.4599 96.3821 46.7066 92.7267 46.7066 88.2175C46.7066 83.7082 50.4599 80.0528 55.0898 80.0528H8.38323C3.7533 80.0528 0 76.3973 0 71.8881C0 67.3789 3.7533 63.7234 8.38323 63.7234H56.2874C60.9174 63.7234 64.6707 60.068 64.6707 55.5587C64.6707 51.0495 60.9174 47.3941 56.2874 47.3941H26.3473C21.7174 47.3941 17.9641 43.7386 17.9641 39.2294C17.9641 34.7202 21.7174 31.0647 26.3473 31.0647H74.2515C69.6216 31.0647 65.8683 27.4093 65.8683 22.9C65.8683 18.3908 69.6216 14.7354 74.2515 14.7354H191.617ZM191.617 47.3941C196.247 47.3941 200 51.0495 200 55.5587C200 60.068 196.247 63.7234 191.617 63.7234C186.987 63.7234 183.234 60.068 183.234 55.5587C183.234 51.0495 186.987 47.3941 191.617 47.3941Z",
    fill: "#D6DCE8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.6155,
    cy: 46.7062,
    rx: 33.2884,
    ry: 32.4196,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1364 51.0324C79.032 51.0324 80.636 49.4703 80.636 47.6241C80.636 45.778 79.032 44.2158 77.1364 44.2158C75.2407 44.2158 73.6367 45.778 73.6367 47.6241C73.6367 49.4703 75.2407 51.0324 77.1364 51.0324Z",
    fill: "#989FB0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.966 51.0324C105.862 51.0324 107.466 49.4703 107.466 47.6241C107.466 45.778 105.862 44.2158 103.966 44.2158C102.071 44.2158 100.467 45.778 100.467 47.6241C100.467 49.6123 102.071 51.0324 103.966 51.0324Z",
    fill: "#989FB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0001 36.3454L69.3018 40.3936L70.3409 42.2679L78.0393 38.2197L77.0001 36.3454Z",
    fill: "#989FB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.49 36.2919L102.451 38.1665L110.15 42.2138L111.189 40.3393L103.49 36.2919Z",
    fill: "#989FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5517 58.9831C92.8066 58.9831 94.6346 57.6479 94.6346 56.0008C94.6346 54.3538 92.8066 53.0186 90.5517 53.0186C88.2967 53.0186 86.4688 54.3538 86.4688 56.0008C86.4688 57.6479 88.2967 58.9831 90.5517 58.9831Z",
    fill: "#989FB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.488 90.1542L111.993 71.1835L116.462 66.8311L135.941 85.8167L131.488 90.1542Z",
    fill: "#858B9B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.195 99.6847L126.247 85.1265C124.998 83.9108 124.998 81.9297 126.247 80.714C127.495 79.4983 129.529 79.4983 130.777 80.714L145.726 95.2722C146.974 96.4879 146.974 98.469 145.726 99.6847C144.478 100.9 142.443 100.9 141.195 99.6847Z",
    fill: "#858B9B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.129 100.618L120.897 81.8872C120.45 81.4519 120.45 80.7465 120.897 80.2963L125.813 75.5086C126.26 75.0733 126.984 75.0733 127.446 75.5086L146.679 94.2391C147.126 94.6744 147.126 95.3797 146.679 95.83L141.763 100.618C141.3 101.053 140.576 101.053 140.129 100.618Z",
    fill: "url(#paint0_linear_35190_4492)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9266 10.0562C69.5229 10.0562 52.9873 26.1602 52.9873 46.0314C52.9873 65.8876 69.5229 82.0066 89.9112 82.0066C110.315 82.0066 126.851 65.9026 126.851 46.0314C126.851 26.1602 110.315 10.0562 89.9266 10.0562ZM89.9266 75.3429C73.5451 75.3429 60.2765 62.2105 60.2765 46.0164C60.2765 29.8223 73.5451 16.7049 89.9266 16.7049C106.308 16.7049 119.577 29.8373 119.577 46.0314C119.577 62.2255 106.293 75.3429 89.9266 75.3429Z",
    fill: "url(#paint1_linear_35190_4492)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 70,
    r: 4.5,
    fill: "#D6DCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35190_4492",
    x1: 120.549,
    y1: 88.0659,
    x2: 147.019,
    y2: 88.0659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35190_4492",
    x1: 52.9535,
    y1: 46.0392,
    x2: 126.864,
    y2: 46.0392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGif);
export default __webpack_public_path__ + "static/media/empty-gif.0db1da1f658960556723162a5543ca6d.svg";
export { ForwardRef as ReactComponent };